<template>
  <div>
    <p >
      <pdf scale="page-width" style="width:100%;margin:20px auto;"  
          :src="sysDoc"
          v-for="i in numPages"
          :key="i"
          :page="i"></pdf>
    </p>
    <!-- <iframe frameborder="0" height="500px" width="100%" :src="'https://docs.google.com/viewer?url='.concat(setting.serverUrl[0].codeName).concat('/WebApi/Tools/ShowSystemDoc/').concat(sysId).concat('/7').concat('&embedded=true')" 
        v-else></iframe>         -->
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'Location',
  data() {
    return {    
      isSafari: false,
      numPages: 0
    }
  },
  components: {
    pdf
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    sysDoc () {
      return pdf.createLoadingTask('./WebApi/Tools/ShowSystemDoc/'.concat(this.$store.getters.getSysId).concat('/7'));
    },
    setting () {
      return this.$store.getters.getSetting
    }
  },
  mounted() {
    this.sysDoc.then(pdf => {
      this.numPages = pdf.numPages;
    });
  },
  created () {
    console.log('======created location =====')
    var userAgent = navigator.vendor;
    let vm = this;
    if (userAgent.indexOf("Apple") > -1) {
        this.isSafari = true;
    } else {
      this.isSafari = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/LocationView.vue